import { routes } from "~/constants";
import { partnerEmailTrackerStem } from "~/OnboardingApp/events";
import { shouldSeeDueDatePage } from "~/OnboardingApp/utils";
import {
  emptyPhase,
  logisticsPhase,
  welcomePhase,
  yourFertilityJourneyPhase,
} from "./constants";
import { MetaByPath } from "./metaByPath";

const analyticsStem = "partner-onboarding";

export const partnerMetaByPath: MetaByPath = {
  [routes.partnerOnboardingRoot]: {
    analyticsStem: `${analyticsStem}-root-page`,
    canRevisit: () => false,
    isPublic: false,
    isAnswered: () => true,
    phase: welcomePhase,
  },
  [routes.partnerOnboardingQuestionName]: {
    analyticsStem: `${analyticsStem}-name-page`,
    canRevisit: () => true,
    isPublic: true,
    isAnswered: ({ firstName, lastName }) => !!(firstName && lastName),
    phase: welcomePhase,
  },
  [routes.partnerOnboardingQuestionEmail]: {
    analyticsStem: partnerEmailTrackerStem,
    isPublic: true,
    canRevisit: ({ email }) => !email,
    isAnswered: ({ email }) => !!email,
    phase: welcomePhase,
  },
  [routes.partnerOnboardingQuestionHowLong]: {
    analyticsStem: `${analyticsStem}-how-long-page`,
    canRevisit: () => true,
    isAnswered: ({ lengthOfTimeTtc }) => !!lengthOfTimeTtc,
    phase: yourFertilityJourneyPhase,
  },
  [routes.partnerOnboardingQuestionDueDate]: {
    analyticsStem: `${analyticsStem}-due-date-page`,
    canRevisit: ({ lengthOfTimeTtc }) =>
      !!lengthOfTimeTtc && shouldSeeDueDatePage(lengthOfTimeTtc),
    isAnswered: ({ dueDate, lengthOfTimeTtc }) =>
      !!dueDate?.length ||
      (!!lengthOfTimeTtc && !shouldSeeDueDatePage(lengthOfTimeTtc)),
    phase: yourFertilityJourneyPhase,
    isOptional: true,
  },
  [routes.partnerOnboardingQuestionProvidersSeen]: {
    analyticsStem: `${analyticsStem}-providers-seen-page`,
    canRevisit: () => true,
    isAnswered: ({ providersSeen }) => !!providersSeen?.length,
    phase: yourFertilityJourneyPhase,
  },
  [routes.partnerOnboardingQuestionProviderSelect]: {
    analyticsStem: `${analyticsStem}-provider-select-page`,
    canRevisit: () => true,
    isAnswered: () => true,
    phase: yourFertilityJourneyPhase,
  },
  [routes.partnerOnboardingQuestionJourneyLooksLike]: {
    analyticsStem: `${analyticsStem}-journey-looks-like-page`,
    canRevisit: () => true,
    isAnswered: ({ journeyLooksLike }) => !!journeyLooksLike?.length,
    phase: yourFertilityJourneyPhase,
  },
  [routes.partnerOnboardingQuestionNextMilestone]: {
    analyticsStem: `${analyticsStem}-next-milestone-page`,
    canRevisit: ({ journeyLooksLike }) => {
      const selectedJourney = journeyLooksLike?.[0] || "";
      return selectedJourney !== "Other";
    },
    isAnswered: ({ upcomingMilestone, journeyLooksLike }) => {
      const selectedJourney = journeyLooksLike?.[0] || "";
      return !!upcomingMilestone?.length || selectedJourney === "Other";
    },
    phase: yourFertilityJourneyPhase,
  },
  [routes.partnerOnboardingQuestionSupportNeeds]: {
    analyticsStem: `${analyticsStem}-support-needs-page`,
    canRevisit: () => true,
    isAnswered: ({ supportNeeds }) => !!supportNeeds?.length,
    phase: yourFertilityJourneyPhase,
  },
  [routes.partnerOnboardingQuestionMostChallenging]: {
    analyticsStem: `${analyticsStem}-most-challenging-page`,
    canRevisit: () => true,
    isAnswered: ({ biggestChallenge }) => !!biggestChallenge,
    isOptional: true,
    phase: yourFertilityJourneyPhase,
  },
  [routes.partnerOnboardingQuestionClinicSatisfaction]: {
    analyticsStem: `${analyticsStem}-clinic-satisfaction-page`,
    canRevisit: () => true,
    isAnswered: ({ clinicSatisfaction }) => !!clinicSatisfaction,
    phase: yourFertilityJourneyPhase,
  },
  [routes.partnerOnboardingQuestionPartner]: {
    analyticsStem: `${analyticsStem}-partner-page`,
    canRevisit: () => true,
    isAnswered: ({ partner }) => !!partner,
    phase: yourFertilityJourneyPhase,
  },
  [routes.partnerOnboardingQuestionBirthday]: {
    analyticsStem: `${analyticsStem}-birthday-page`,
    canRevisit: () => true,
    isAnswered: ({ bornOn }) => !!bornOn,
    phase: logisticsPhase,
  },
  [routes.partnerOnboardingQuestionPhone]: {
    analyticsStem: `${analyticsStem}-phone-page`,
    canRevisit: () => true,
    isAnswered: ({ international, phone }) => international || !!phone,
    phase: logisticsPhase,
  },
  [routes.partnerOnboardingInterstitialThanksForSharing]: {
    analyticsStem: `${analyticsStem}-thanks-for-sharing-page`,
    canRevisit: () => true,
    isAnswered: ({ international, phone }) => international || !!phone,
    phase: emptyPhase,
    excludeFromBack: true,
    excludeFromProgress: true,
    excludeNav: true,
  },
};
